import * as React from 'react';
export var Modal = function (_a) {
    var children = _a.children, _b = _a.disableEscDismiss, disableEscDismiss = _b === void 0 ? false : _b, _c = _a.topOffset, topOffset = _c === void 0 ? 0 : _c, onClose = _a.onClose;
    React.useEffect(function () {
        if (disableEscDismiss) {
            return function () { };
        }
        var listener = function (event) {
            switch (event.key) {
                case 'Esc':
                case 'Escape':
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                default:
                    return;
            }
        };
        document.body.addEventListener('keyup', listener);
        return function () {
            document.body.removeEventListener('keyup', listener);
        };
    }, [disableEscDismiss, onClose]);
    return (<div aria-labelledby='modal-title' aria-modal='true' className='fixed z-10 inset-0 overflow-y-auto' role='dialog'>
			<div className='flex items-end md:items-center justify-center min-h-screen md:pt-4 md:px-4 text-center sm:block sm:p-0'>
				<div aria-hidden='true' className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' onClick={function () {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }}/>
				<div className='inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 w-full sm:max-w-4xl' style={{ top: topOffset }}>
					{children}
				</div>
			</div>
		</div>);
};
Modal.displayName = 'UI.Modal';
export var ModalFooter = function (_a) {
    var children = _a.children;
    return (<div className='bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse'>{children}</div>);
};
ModalFooter.displayName = 'UI.ModalFooter';
